import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, ProdBeoMethodItem, ProductionPlaceItem, StockplaceItem, UnitItem } from '../../../services/logistic.service';
import { ProductService, ProductTypeItem } from '../../../services/product.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-furniture-fabrics',
  templateUrl: './furniture-fabrics.component.html',
  styleUrls: ['./furniture-fabrics.component.css']
})
export class FurnitureFabricsComponent implements OnInit {
    public furnitureFabricsId: string;

    public productGroupButtons: FormButton[] = [{ id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'prodgrps' }];

    public collectionButtons: FormButton[] = [{ id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'collections' }];

    public colourGroupButtons: FormButton[] = [{ id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'colorgrps' }];

    public fabricGroupButtons: FormButton[] = [{ id: 'list', icon: 'fa fa-bars', type: 'primary', goto: 'fabricsgrps' }];

    public edit?: Edit;

    public selectListProductTypes: ProductTypeItem[] = [];

    public selectListUnits: UnitItem[] = [];

    public selectListProductGroups: Item[] = [];

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListProductionPlaces: ProductionPlaceItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public selectListCollections: Item[] = [];

    public selectListColourGroups: Item[] = [];

    public selectListProdBeoMethods: ProdBeoMethodItem[] = [];

    public selectListProductChoices: ProductChoiceItem[] = [];

    public selectListFabricGroups: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private productService: ProductService, private typeahead: TypeaheadService) {
        this.furnitureFabricsId = this.stateService.getStateParams()['furniturefabrics_id'];
    }

    private async loadEdit() {
        if (!!this.furnitureFabricsId) {
            this.edit = (await this.datatask.Post(1182, { furniturefabrics_id: this.furnitureFabricsId }))[0];
        }
    }

    private async loadProductTypes() {
        this.selectListProductTypes = await this.productService.getProductTypes();
    }

    private async loadUnits() {
        this.selectListUnits = await this.logistic.getUnitList();
    }

    private async loadProductGroups() {
        this.selectListProductGroups = await this.productService.getProductGroups();
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadProductionPlaces() {
        this.selectListProductionPlaces = await this.logistic.getProductionPlaces();
    }

    private async loadCollections() {
        this.selectListCollections = await this.productService.getCollections();
    }

    private async loadColourGroups() {
        this.selectListColourGroups = await this.datatask.Post(1204);
    }

    private async loadProdBeoMethods() {
        this.selectListProdBeoMethods = await this.logistic.getProdBeoMethods();
    }

    private async loadProductChoices() {
        this.selectListProductChoices = await this.datatask.Post(1159);
    }

    private async loadFabricGroups() {
        this.selectListFabricGroups = await this.datatask.Post(1240);
    }

    private async loadStockPlaces() {
        if (!this.edit) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.edit.businessco_no });
    }

    public searchSupplierNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit!.supplier_name,
            custtype: 'S',
            lastselect: 'SEARCH'
        });
    }

    public onSupplierNameSelected(event?: Item) {
        if (!this.edit) return;

        this.edit.supplier_no = !!event ? '' + event.item_id : '0';
        this.edit.supplier_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1217, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadProductTypes();
        this.loadUnits();
        this.loadProductGroups();
        this.loadCompanies();
        this.loadProductionPlaces();
        this.loadCollections();
        this.loadColourGroups();
        this.loadProdBeoMethods();
        this.loadProductChoices();
        this.loadFabricGroups();
        this.loadStockPlaces();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    furniturefabrics_id: string;
    furniturefabrics_name: string;
    prodtype_no: string;
    prod_stock_unit_no: string;
    prodgrp_id: string;
    prodplace_id: string;
    prod_designinfo: string;
    note: string;
    prod_price_unit_no: string;
    stockplace_id: string;
    businessco_no: string;
    isactive: string;
    isnew: string;
    collection_keyno: string;
    colorgrp_id: string;
    prodbeomethod_no: string;
    structure_product: string;
    martindale: string;
    width_m: string;
    washable: string;
    soft_pillows: string;
    structure_factor: string;
    report: string;
    pattern_adjustment: string;
    startpoint_pattern: string;
    chains: string;
    fabricsgrp_id: string;
    nbr_of_custacts: string;
    supplier_no: string;
    supplier_name: string;
}

interface ProductChoiceItem {
    prod_id: string;
    prod_name: string;
    orderby: string;
}
